import React, { FC, useLayoutEffect } from 'react';
import { Setting } from '../App';
import classes from '../asset/css/main.module.css';
import { Cancel } from '../components/subscription-cancel/Cancel';
import { useSubscriptionCancel } from '../hooks/use-subscription-cancel';
import {useHistory} from "react-router-dom";

export const SubscriptionCancel: FC<{ setting: Setting }> = ({ setting }) => {
  const history = useHistory();
  const { subscriptionCancel } = useSubscriptionCancel(setting);

  useLayoutEffect(() => {
    const height = document.querySelector('body')!.scrollHeight

    setting.resize(height)
  }, [])

  return (
    <>
      <div className={classes.mypage_subsc_container}>
        <Cancel
          subscriptionCancelFunc={() => {
            subscriptionCancel(
              () => {history.push('/cancel/complete')},
              (message) => console.log(message)
            );
          }}
        />
      </div>
    </>
  );
};
